module.exports = __webpack_public_path__ + "img/xl-logo.5d583d75.png";